import { SqlValue } from '@sqlite.org/sqlite-wasm'

import { generateRandomID } from '../utils/numbers'
import { ISQLExecutor } from './ISQLExecutor'
import { RecordFactory } from './RecordFactory'
import { SQLBuilder } from './SQLBuilder'
import { SQLiteFactory, WorkerRequest } from './SQLiteFactory'

export class SQLTransactionManager implements ISQLExecutor {
    public recordFactory: RecordFactory
    public readonly correlationId: string

    constructor() {
        this.correlationId = generateRandomID()
        this.recordFactory = new RecordFactory(this)
    }

    private enqueuePromise(req: WorkerRequest) {
        return SQLiteFactory.getInstance().proxy['enqueueRequest'](req)
    }

    async executeSql(payload: SQLBuilder) {
        return this.enqueuePromise({
            type: 'exec',
            transactionCorrelationId: this.correlationId,
            payload: payload.serialize(),
        })
    }

    async executeSingleRowQuery(payload: SQLBuilder) {
        return this.enqueuePromise({
            type: 'exec',
            transactionCorrelationId: this.correlationId,
            payload: payload.serialize(),
            singleRow: true,
        })
    }

    async executeUpdate(sql: string, ...binds: SqlValue[]) {
        return this.enqueuePromise({
            type: 'exec',
            transactionCorrelationId: this.correlationId,
            payload: { ...new SQLBuilder({ binds: binds }).serialize(), sql },
        })
    }

    async setBadgeCount(badgeCount: number) {
        return this.enqueuePromise({
            type: 'exec',
            transactionCorrelationId: this.correlationId,
            payload: {
                ...new SQLBuilder({ binds: [badgeCount] }).serialize(),
                sql: 'UPDATE status SET badgeCount=?',
            },
        })
    }

    async setRoleBadgeCount(roleBadgeCount: number) {
        return this.enqueuePromise({
            type: 'exec',
            transactionCorrelationId: this.correlationId,
            payload: {
                ...new SQLBuilder({ binds: [roleBadgeCount] }).serialize(),
                sql: 'UPDATE status SET roleBadgeCount=?',
            },
        })
    }

    begin() {
        return this.enqueuePromise({
            type: 'start_transaction',
            transactionCorrelationId: this.correlationId,
        })
    }

    commit() {
        return this.enqueuePromise({
            type: 'end_transaction',
            transactionCorrelationId: this.correlationId,
        })
    }

    rollback() {
        return this.enqueuePromise({
            type: 'rollback_transaction',
            transactionCorrelationId: this.correlationId,
        })
    }
}
